document.addEventListener('click', async (event) => {
  const button = event.target.closest('.cart-drawer-upsell__add-button');
  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
      }),
    });

    if (!addResponse.ok) {
      throw new Error('Failed to add item');
    }

    const cartComponent = button.closest('cart-items-component');
    const sectionId = cartComponent?.dataset.sectionId;

    if (!sectionId) {
      throw new Error('Missing section id');
    }

    const sectionResponse = await fetch(`/?section_id=${sectionId}`);
    if (!sectionResponse.ok) {
      throw new Error('Failed to reload cart section');
    }

    const sectionHtml = await sectionResponse.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');

    const currentDrawerInner = document.querySelector('.cart-drawer__inner');
    const newDrawerInner = doc.querySelector('.cart-drawer__inner');

    if (currentDrawerInner && newDrawerInner) {
      currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
    }

    const currentTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    const newTrigger = doc.querySelector('[data-testid="cart-drawer-trigger"]');

    if (currentTrigger && newTrigger) {
      currentTrigger.innerHTML = newTrigger.innerHTML;
    }

    button.textContent = 'Added';
  } catch (error) {
    console.error(error);
    button.textContent = 'Error';

    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1200);

    return;
  }
});